/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPreferences.defs'
export { main as default } from './getPreferences.defs'
